// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"a3b2f3b5a70be863910e","655":"4099ead5050d699badaf"}[chunkId] + ".js";
};